const salesContact = {
  buttonText: Drupal.t('Find Sales Contact'),
  change: Drupal.t('Change'),
  countryPlaceholder: Drupal.t('Select your country'),
  cropsPlaceholder: Drupal.t('Select the crop you need products for'),
  findLocalSalesContact: Drupal.t('Find your local sales contact'),
  introText: Drupal.t(
    'Our sales consultants are here to help professional growers get the most out of their crops and order our products from the nearest distributor.',
  ),
  meta: {
    country: Drupal.t('Country'),
    crop: Drupal.t('Crop'),
    zipCode: Drupal.t('Zip-Code'),
  },
  noResultsCountry: Drupal.t(
    'No results. Check for spelling errors or search for another country.',
  ),
  placeholderImageAlt: Drupal.t('Contact person'),
  regionsPlaceholder: Drupal.t('Select a region'),
  resultTitleText: Drupal.t('Your Sales Contact'),
  salesContactTitle: Drupal.t('Your local sales contact'),
  searchPlaceholder: Drupal.t('Search ...'),
  zipCodePlaceholder: Drupal.t('Enter your ZIP code'),
};

export default salesContact;
